/**
* Hero Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'hero-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const heroContent = $( '.hero-banner__content' );
      const heroContentHeight = heroContent.outerHeight();

      $( ':root' ).get( 0 ).style.setProperty( '--hero-content', `${heroContentHeight}px` );
      if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
        // add the animation to the content block
        gsap.to( heroContent, {y: '0%', delay: 1, duration: 2.5, ease: 'power3.out'} );
      }


      $( '.hero-banner__image' ).each( function( key, val ) {
        let image = $( this ).find( '.fit-image' )[0];

        if ( $( this ).find( '.loop-video-container' ).length ) {
          image = $( this ).find( '.loop-video-container' )[0];
        }

        const heroBanner = $( '.hero-banner__image' );
        const bgImg = $( '.hero-banner .inner-container' );

        if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
          const imageTl = gsap.timeline( );
          // gsap.set( image, {y: '100%', visibility: 'none'} );
          // imageTl.to( image, {autoAlpha: 1, duration: 0} );
          gsap.to( image, {y: '0%', delay: .5, duration: 2.5, ease: 'power3.out'} );
          gsap.to( bgImg, {
            y: +200,
            scrollTrigger: {
              trigger: heroBanner,
              start: 'top top+=90px',
              end: 'bottom 0%',
              scrub: true,
            },
          } );
        }
      } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        const heroContent = $( '.hero-banner__content' ).outerHeight();
        $( ':root' ).get( 0 ).style.setProperty( '--hero-content', `${heroContent}px` );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-banner', COMPONENT );
} )( app );
